import { Text, useIntl } from 'platform-components';
import React from 'react';

import './certificate-modal__conditions.scss';

export const CertificateModalConditions = () => {
    const intl = useIntl();
    const title = intl.formatMessage({ id: 'certificatesModal.conditions.title' });

    if (!title || title.trim() === '') {
        return null;
    }

    return (
        <div className="certificate-modal__conditions">
            <div className="certificate-modal__conditions-title">
                <Text size={Text.SIZE.XL}>{title}</Text>
            </div>
        </div>
    );
};
